import axios from "axios";
import { API_CONSTS } from "../../../constants";

interface IGetUserTokensProps {
  applicationId: string;
  code: string;
}
// TODO:the /tokens endpoint is not finished on the API side: plug this fn back into the PasswordChangeSuccessView component when ready
// custom hook for getting tokens outside the normal login flow (i.e. after successful password reset)
export const getUserTokens = async ({
  applicationId,
  code,
}: IGetUserTokensProps) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), 8000);
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}/${API_CONSTS.AUTH_API_PATH}/sso/tokens`,
      method: "get",
      responseType: "json",
      headers: {
        code,
        "x-application": applicationId,
      },
      signal: controller.signal,
    });

    clearTimeout(id);

    if (response.status !== 200) return null;

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
